import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate, useParams } from "react-router-dom";
import { RouteName } from "constants/route";
import { ILoadingWithPage } from "models";
import createFaqValidator from "validators/createFaq.validator";
import { IFaqInput } from "models/faq";
import { fetchFaqByIdApi, updateFaqApi } from "api/faq";

export default function useEditFaq() {
  const id: string = useParams().id!;
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<ILoadingWithPage>({
    button: false,
    page: true,
  });
  const { control, handleSubmit, setValue } = useForm<IFaqInput>({
    resolver: yupResolver(createFaqValidator),
  });

  useEffect(() => {
    fetchFaqByIdApi(id).then(({ data, error }) => {
      if (data) {
        setValue("title", data.data.title);
        setValue("description", data.data.description);
        setValue("type", data.data.type);
        setLoading({ button: false, page: false });
      } else showError(error!.message);
    });
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (input: IFaqInput) => {
    setLoading({ button: true, page: false });
    const { data, error } = await updateFaqApi(id, input);
    if (data) {
      showSuccess("Faq updated Successfully");
      navigate(RouteName.FAQ, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading({ button: false, page: false });
  };

  return { handleSubmit, onSubmit, control, loading };
}
